
import { isEmpty } from "../gui_components/Util.js";
import {ServiceExecutorProxy}from "./ServiceExecutorProxy.js";
export class LogisticOrderReceiptService {
  constructor() {}
  static initService(appData) {
    this.sessionBean = JSON.parse(localStorage.getItem("session"));
    this.companyCode = appData.companyCode;
    this.data_url =
      appData.serviceURL + `/${process.env.REACT_APP_LR_SERVICE_PATH}`;
    localStorage.setItem("security_token", this.sessionBean.securityPass);
  }
  static lockLogisticOrderReceiptNumber(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "lockLogisticOrderReceiptNumber",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static unLockLogisticOrderReceiptNumber(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "unLockLogisticOrderReceiptNumber",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createLogisticOrderReceipt(input, responseCallBack, errorCallBack) {
    this.method(
      "createLogisticOrderReceipt",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static initLogisticOrderReceiptModule(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "initLogisticOrderReceiptModule",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getLogisticOrderReceiptPageList(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getLogisticOrderReceiptPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createAndApproveLogisticOrderReceipt(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "createAndApproveLogisticOrderReceipt",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updateLogisticOrderReceipt(input, responseCallBack, errorCallBack) {
    this.method(
      "updateLogisticOrderReceipt",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updateAndApproveLogisticOrderReceipt(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "updateAndApproveLogisticOrderReceipt",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static approveLogisticOrderReceipt(input, responseCallBack, errorCallBack) {
    this.method(
      "approveLogisticOrderReceipt",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static unApproveLogisticOrderReceipt(input, responseCallBack, errorCallBack) {
    this.method(
      "unApproveLogisticOrderReceipt",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static cancelLogisticOrderReceipt(input, responseCallBack, errorCallBack) {
    this.method(
      "cancelLogisticOrderReceipt",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static cancelLogisticOrderReceiptLine(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "cancelLogisticOrderReceiptLine",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createInvoiceFromLogisticOrderReceipt(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "createInvoiceFromLogisticOrderReceipt",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static cancelAndUnLockLogisticOrderReceiptAfterApproval(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "cancelAndUnLockLogisticOrderReceiptAfterApproval",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getLogisticOrderReceiptInvoiceList(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getLogisticOrderReceiptInvoiceList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static uploadExcelInput(input, responseCallBack, errorCallBack) {
    this.method("uploadExcelInput", input, responseCallBack, errorCallBack);
  }
  static getLogisticOrderReceiptRollLinesDatasFromExcel(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getLogisticOrderReceiptRollLinesDatasFromExcel",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static logisticReceiptImageUpload(input, responseCallBack, errorCallBack) {
    this.method(
      "logisticReceiptImageUpload",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static logisticReceiptDocUpload(input, responseCallBack, errorCallBack) {
    this.method(
      "logisticReceiptDocUpload",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  
  static updateLogisticOrderReceiptAfterApproval(input, responseCallBack, errorCallBack) {
    this.method(
      "updateLogisticOrderReceiptAfterApproval",
      input,
      responseCallBack,
      errorCallBack
    );
  }  

  static method(methodName, input, responseCallBack, errorCallBack) {
    if (isEmpty(this.sessionBean)) {
    } else if (isEmpty(this.sessionBean.securityPass)) {
    } else {
      //   const isFormData = input instanceof FormData;
      // axios({
      //   method: "post",
      //   url: this.data_url + "/" + methodName,
      //   data: input,
      //   headers: {
      //     securitykey: localStorage.getItem("security_token"),
      //     Accept: "application/json",
      //     // "Content-Type": "application/json",
      //     ...(isFormData ? {} : { "Content-Type": "application/json" })
      //   },
      // })
      //   .then((response) => {
      //     responseCallBack(response);
      //   })
      //   .catch((error) => {
      //     errorCallBack(error);
      //     ShowError("Erro : " + error);
      //   });
       ServiceExecutorProxy.executeService(methodName, input,this.data_url,responseCallBack, errorCallBack);
    }
  }
}
